import Config from "./config/config";
import Locale from "./config/locale";

console.log(Config.api);
export default {
  modules: {
    authentication: {
      strict: true,
      namespaced: true,
      state: {
        authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
        name: Config.getCookie("name") != "" ? Config.getCookie("name") : null,
        username: Config.getCookie("username") != "" ? Config.getCookie("username") : null,
        account_type: Config.getCookie("account_type") != "" ? Config.getCookie("account_type") : null,
        loggedIn: Config.getCookie("auth") != "" ? true : false,
		  loading: false,
		  url: ""
      },
      mutations: {
        login (state, data) {
          state.loggedIn = true
        }
      }
    },
	 lang: {
      strict: true,
      namespaced: true,
      state: {
			language: Config.getLanguage(Config.getCookie("language")),
			text: Locale,
		},
      mutations: {
			switchLanguage (state, code) {
				state.language = code;
				// for(let i = 0; i< Locale)
			 }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js